import React, { Component } from 'react';

class RefundPolicy extends Component {
    render() {
        return (
            <>
                <section>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-10">
                                <div className="message-box success">
                                    <h2>Refund Policy</h2>
                                    <p>All cancellations must be done through the <strong>web portal, email, WhatsApp (Contact number – 0044(0)7477018889), or hotline number (Conact no - 0331-630-4331).</strong> We might not have received your email if you do not receive confirmation from MyBoogy Airport Transfer that the cancellation has been made. </p>
                                    <p>Three hours' notice is what MyBoogy Airport Transfers need prior to the pick-up/Drop time. MyBoogy Airport Transfer will guarantee a refund and only impose a 2.5% transaction fee against the booking amount assessed by the online payment service provider. You will receive confirmation from us on completion of the refund process.</p>
                                    <p>Complete Refund will be made within 5 to 7 working days if the cancellation is made more than three hours from the scheduled journey time (after deducting 2.5% of the transaction fee). Please give our customer service department a call in this situation if you don’t receive the refund within the stipulated time.</p>
                                    <p>In the following situations, there will be no reimbursement:</p>
                                    <p>a) Passenger 'no show'/ uncontactable via call/ WhatsApp message (on the provided phone number) for pre-paid journeys.</p>
                                    <p>b) Booking cancellation with less than 3 hours’ notice.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}

export default RefundPolicy;